module.exports={
	"Form": "CoreViewManifest",
	"Scope": "Core-View",
	"Descriptors":
	{
		"CoreDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Core-View-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "Core-View-Identity",
				"Group": "Core-View-Identity"
			}
		},
		"CoreDetails.IDLot":
		{
			"Name": "Lot",
			"Hash": "Core-View-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details",
				"Entity": "Lot",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"CoreDetails.IDSublot":
		{
			"Name": "IDSublot",
			"Hash": "Core-View-IDSublot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.IDSample":
		{
			"Name": "Sample",
			"Hash": "Core-View-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				],
				"ReadOnly": true
			}
		},
		"CoreDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Core-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"CoreDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Core-View-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Core-View-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.SublotName":
		{
			"Name": "Sublot Name",
			"Hash": "Core-View-SublotName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Core-View-Details",
				"Group": "Core-View-Details"
			}
		},
		"CoreDetails.IDCore":
		{
			"Name": "IDCore",
			"Hash": "Core-View-IDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.GUIDCore":
		{
			"Name": "GUIDCore",
			"Hash": "Core-View-GUIDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Core-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Core-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Core-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		},
		"CoreDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Core-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-View-DataAudit",
				"Group": "Core-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Core-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Core-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Core-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Core-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Core-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Core-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
